import {Component, Input, OnChanges, OnDestroy, OnInit} from "@angular/core";
import {AppSettingsService} from "./app-settings.service";
import {Subscription} from "rxjs";
import {AuthDetailModel} from "./auth-detail.model";
import _ = require("lodash");

@Component({
  selector: "user-detail",
  templateUrl: "./user-detail.template.pug"
})
export class UserDetailComponent implements OnInit, OnDestroy {
  private userSubscription: Subscription;
  private currentuser: AuthDetailModel;

  @Input("key")
  key: keyof AuthDetailModel;

  text: string = "";
  roles = [];
  showRoles = false;

  constructor(private appSettingsService: AppSettingsService) {}

  ngOnInit() {
    this.userSubscription = this.appSettingsService.user.subscribe((user) => {
      this.text = `${user[this.key]}`;
      this.roles = _.clone(user.roles);
    });
  }

  ngOnDestroy() {
    if (this.userSubscription && !this.userSubscription.closed) {
      this.userSubscription.unsubscribe();
    }
  }
}
